export const getFullTimeExternalScoreRate = (tech, bookingRow) => {
  const props = (bookingRow && bookingRow.extendedProps) || {};
  const name = String((tech && tech.name) || "").trim();
  const recorder = String(props.techrecord || "").trim();
  const scorer = String(props.technician || "").trim();

  return tech &&
    tech.employmentType === "Full Time" &&
    name &&
    scorer === name &&
    recorder &&
    recorder !== name
    ? 300
    : null;
};
